import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import {FileChooserListElementComponent} from './file-chooser-list-element.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule,
  ],
  declarations: [FileChooserListElementComponent],
  providers: [],
  exports: [FileChooserListElementComponent]
})

export class FileChooserListElementModule {

}
